import { isApiError } from "@bw/shared/api";

/** Recognize setup authentication only; never drive a charge challenge here. */
export function cardSetupClientSecret(error: unknown): string | null {
  if (
    !isApiError(error) ||
    error.status !== 402 ||
    error.code !== "PAYMENT_AUTHENTICATION_REQUIRED"
  )
    return null;
  const secret = error.details?.client_secret;
  return typeof secret === "string" && secret.length > 0 ? secret : null;
}
